import axiosInstance from "../AxiosInstance";
import { URLS } from "../API/API endpoints";
import { store } from "../Redux/store";
import i18next from "i18next";



export const getCreditPaymentHistory = async (payload) => {
    try {
        const response = await axiosInstance.post(
            URLS.GET_CREDIT_PAYMENT_HISTORY,
            payload
        );
        console.log("GET_POS_SESSION_HISTORY", response);

        return response.data;
    } catch (error) {
        return error;
    }
};

export const getGroupWiseSales = async (payload) => {
    try {
        const response = await axiosInstance.post(
            URLS.GET_GROUP_WISE_SALES,
            payload
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

